import { useEffect, useState } from 'react'
import api from '../services/api'
import './PortalTools.css'

function SeguridadPage() {
  const [policy, setPolicy] = useState('')
  const [supported, setSupported] = useState(true)
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [pwdMsg, setPwdMsg] = useState('')
  const [pwdError, setPwdError] = useState('')
  const [pwdLoading, setPwdLoading] = useState(false)

  const [mfaEnabled, setMfaEnabled] = useState(false)
  const [mfaDisabledGlobally, setMfaDisabledGlobally] = useState(false)
  const [qr, setQr] = useState('')
  const [otp, setOtp] = useState('')
  const [recoveryCodes, setRecoveryCodes] = useState([])
  const [mfaMsg, setMfaMsg] = useState('')
  const [mfaError, setMfaError] = useState('')

  useEffect(() => {
    api.get('/auth/password/status').then((res) => {
      setSupported(res.data?.supported !== false)
      setPolicy(res.data?.policyText || '')
    }).catch(() => {})
    api.get('/auth/mfa/status').then((res) => {
      setMfaEnabled(!!res.data?.enabled)
      setMfaDisabledGlobally(!!res.data?.globallyDisabled)
    }).catch(() => {})
  }, [])

  const changePassword = async (e) => {
    e.preventDefault()
    setPwdError('')
    setPwdMsg('')
    setPwdLoading(true)
    try {
      const res = await api.post('/auth/password/change', { currentPassword, newPassword, confirmPassword })
      setPwdMsg(res.data?.message || 'Contraseña actualizada')
      setCurrentPassword('')
      setNewPassword('')
      setConfirmPassword('')
    } catch (err) {
      const rules = err.response?.data?.failedRules
      setPwdError(err.response?.data?.error || (Array.isArray(rules) ? rules.join(' ') : 'No se pudo cambiar la contraseña'))
    } finally {
      setPwdLoading(false)
    }
  }

  const startMfa = async () => {
    setMfaError('')
    setMfaMsg('')
    setRecoveryCodes([])
    try {
      const res = await api.post('/auth/mfa/setup')
      setQr(res.data?.qrDataUrl || '')
      setMfaMsg('Escaneá el QR con Google Authenticator y confirmá el código.')
    } catch (err) {
      setMfaError(err.response?.data?.error || 'No se pudo iniciar el 2FA')
    }
  }

  const enableMfa = async (e) => {
    e.preventDefault()
    setMfaError('')
    try {
      const res = await api.post('/auth/mfa/enable', { code: otp })
      setMfaEnabled(true)
      setQr('')
      setOtp('')
      setRecoveryCodes(res.data?.recoveryCodes || [])
      setMfaMsg('Autenticación en dos pasos activada. Guardá los códigos de recuperación.')
    } catch (err) {
      setMfaError(err.response?.data?.error || 'Código inválido')
    }
  }

  const disableMfa = async () => {
    if (!window.confirm('¿Desactivar la autenticación en dos pasos?')) return
    setMfaError('')
    try {
      await api.post('/auth/mfa/disable')
      setMfaEnabled(false)
      setRecoveryCodes([])
      setMfaMsg('2FA desactivado')
    } catch (err) {
      setMfaError(err.response?.data?.error || 'No se pudo desactivar')
    }
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Seguridad</h1>
        <p>Contraseña y autenticación en dos pasos.</p>
      </div>

      <form className="tool-card" onSubmit={changePassword}>
        <h3>Cambiar contraseña</h3>
        {policy && <p className="tool-desc">{policy}</p>}
        {!supported && <p className="tool-desc">Esta cuenta no puede cambiar la contraseña desde el portal.</p>}
        <label>Contraseña actual</label>
        <input type="password" className="form-control" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} disabled={!supported} />
        <label>Nueva contraseña</label>
        <input type="password" className="form-control" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} disabled={!supported} />
        <label>Confirmar</label>
        <input type="password" className="form-control" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} disabled={!supported} />
        {pwdError && <div className="alert alert-error">{pwdError}</div>}
        {pwdMsg && <div className="alert alert-success">{pwdMsg}</div>}
        <button className="btn-primary pwd-submit" disabled={!supported || pwdLoading}>
          {pwdLoading ? 'Guardando...' : 'Actualizar contraseña'}
        </button>
      </form>

      {!mfaDisabledGlobally && (
        <div className="tool-card">
          <h3>Google Authenticator</h3>
          <p className="tool-desc">{mfaEnabled ? 'El segundo factor está activo.' : 'Opcional. Te va a pedir un código al iniciar sesión.'}</p>
          {mfaError && <div className="alert alert-error">{mfaError}</div>}
          {mfaMsg && <div className="alert alert-success">{mfaMsg}</div>}
          {mfaEnabled ? (
            <button type="button" className="btn-secondary" onClick={disableMfa}>Desactivar 2FA</button>
          ) : (
            <>
              {!qr && (
                <button type="button" className="btn-primary" onClick={startMfa}>
                  Configurar 2FA
                </button>
              )}
              {qr && (
                <form onSubmit={enableMfa}>
                  <img src={qr} alt="Código QR de autenticación" className="mfa-qr" />
                  <label>Código de 6 dígitos</label>
                  <input className="form-control" value={otp} onChange={(e) => setOtp(e.target.value)} inputMode="numeric" maxLength={6} />
                  <button className="btn-primary">Activar</button>
                </form>
              )}
            </>
          )}
          {recoveryCodes.length > 0 && (
            <ul className="recovery-list">
              {recoveryCodes.map((code) => <li key={code}>{code}</li>)}
            </ul>
          )}
        </div>
      )}
    </div>
  )
}

export default SeguridadPage
